var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "Ordercontent" },
    [
      _c(
        "van-tabs",
        {
          on: { click: _vm.changeTab },
          model: {
            value: _vm.active,
            callback: function($$v) {
              _vm.active = $$v
            },
            expression: "active"
          }
        },
        [
          _c(
            "van-tab",
            { attrs: { title: "全部" } },
            [
              _vm._l(_vm.OrderList, function(item) {
                return _vm.OrderList
                  ? _c(
                      "van-row",
                      { key: item.ID, attrs: { disabled: item.status != 0 } },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "billBar",
                            attrs: { href: "javascript:;" },
                            on: {
                              click: function($event) {
                                return _vm.gotoOrderPay(item)
                              }
                            }
                          },
                          [
                            _c("van-col", { attrs: { span: "2" } }, [
                              item.status == "0"
                                ? _c(
                                    "span",
                                    { staticClass: "Status StayColor" },
                                    [_vm._v("待")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.status == "1,5,6,7"
                                ? _c(
                                    "span",
                                    { staticClass: "Status Coloring" },
                                    [_vm._v("维")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.status == "10"
                                ? _c(
                                    "span",
                                    { staticClass: "Status CompleteColor" },
                                    [_vm._v("已")]
                                  )
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _c(
                              "van-col",
                              { attrs: { span: "23", offset: "1" } },
                              [
                                _c(
                                  "van-row",
                                  [
                                    _c(
                                      "van-col",
                                      {
                                        staticClass: "cont",
                                        attrs: { span: "24" }
                                      },
                                      [
                                        _c(
                                          "van-col",
                                          {
                                            staticClass: "address",
                                            attrs: { span: "24" }
                                          },
                                          [_vm._v(_vm._s(item.address))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "van-col",
                                          {
                                            staticClass: "reason",
                                            attrs: { span: "24" }
                                          },
                                          [_vm._v(_vm._s(item.reason))]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    item.status == "0"
                                      ? _c(
                                          "van-col",
                                          {
                                            staticClass: "statusText",
                                            attrs: { span: "24" }
                                          },
                                          [_vm._v("待接单")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    item.status == "1,5,6,7"
                                      ? _c(
                                          "van-col",
                                          {
                                            staticClass: "statusText",
                                            attrs: { span: "24" }
                                          },
                                          [_vm._v("维修中")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    item.status == "10"
                                      ? _c(
                                          "van-col",
                                          {
                                            staticClass: "statusText",
                                            attrs: { span: "24" }
                                          },
                                          [_vm._v("已完成")]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    )
                  : _vm._e()
              }),
              _vm._v(" "),
              _vm.OrderList.length == 0
                ? _c(
                    "van-row",
                    { staticClass: "noPayBar" },
                    [
                      _c("van-col", {
                        staticClass: "noPayPC",
                        attrs: { span: "24" }
                      }),
                      _vm._v(" "),
                      _c(
                        "van-col",
                        { staticClass: "text1 orange", attrs: { span: "24" } },
                        [_vm._v("没有找到该用户！")]
                      ),
                      _vm._v(" "),
                      _c(
                        "van-col",
                        { staticClass: "text2", attrs: { span: "24" } },
                        [_vm._v("去试试【自主信息填写缴费】吧！")]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "van-tab",
            { attrs: { title: "待分配" } },
            [
              _vm._l(_vm.OrderList, function(item) {
                return _vm.OrderList
                  ? _c(
                      "van-row",
                      { key: item.ID, attrs: { disabled: item.status != 0 } },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "billBar",
                            attrs: { href: "javascript:;" },
                            on: {
                              click: function($event) {
                                return _vm.gotoOrderPay(item)
                              }
                            }
                          },
                          [
                            _c("van-col", { attrs: { span: "2" } }, [
                              item.status == "0"
                                ? _c(
                                    "span",
                                    { staticClass: "Status StayColor" },
                                    [_vm._v("待")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.status == "1,5,6,7"
                                ? _c(
                                    "span",
                                    { staticClass: "Status Coloring" },
                                    [_vm._v("维")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.status == "10"
                                ? _c(
                                    "span",
                                    { staticClass: "Status CompleteColor" },
                                    [_vm._v("已")]
                                  )
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _c(
                              "van-col",
                              { attrs: { span: "23", offset: "1" } },
                              [
                                _c(
                                  "van-row",
                                  [
                                    _c(
                                      "van-col",
                                      {
                                        staticClass: "cont",
                                        attrs: { span: "24" }
                                      },
                                      [
                                        _c(
                                          "van-col",
                                          {
                                            staticClass: "address",
                                            attrs: { span: "24" }
                                          },
                                          [_vm._v(_vm._s(item.address))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "van-col",
                                          {
                                            staticClass: "reason",
                                            attrs: { span: "24" }
                                          },
                                          [_vm._v(_vm._s(item.reason))]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    item.status == "0"
                                      ? _c(
                                          "van-col",
                                          {
                                            staticClass: "statusText",
                                            attrs: { span: "24" }
                                          },
                                          [_vm._v("待接单")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    item.status == "1,5,6,7"
                                      ? _c(
                                          "van-col",
                                          {
                                            staticClass: "statusText",
                                            attrs: { span: "24" }
                                          },
                                          [_vm._v("维修中")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    item.status == "10"
                                      ? _c(
                                          "van-col",
                                          {
                                            staticClass: "statusText",
                                            attrs: { span: "24" }
                                          },
                                          [_vm._v("已完成")]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    )
                  : _vm._e()
              }),
              _vm._v(" "),
              _vm.OrderList.length == 0
                ? _c(
                    "van-row",
                    { staticClass: "noPayBar" },
                    [
                      _c("van-col", {
                        staticClass: "noPayPC",
                        attrs: { span: "24" }
                      }),
                      _vm._v(" "),
                      _c(
                        "van-col",
                        { staticClass: "text1 orange", attrs: { span: "24" } },
                        [_vm._v("没有找到该用户！")]
                      ),
                      _vm._v(" "),
                      _c(
                        "van-col",
                        { staticClass: "text2", attrs: { span: "24" } },
                        [_vm._v("去试试【自主信息填写缴费】吧！")]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "van-tab",
            { attrs: { title: "维修中" } },
            [
              _vm._l(_vm.OrderList, function(item) {
                return _vm.OrderList
                  ? _c(
                      "van-row",
                      { key: item.ID, attrs: { disabled: item.status != 0 } },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "billBar",
                            attrs: { href: "javascript:;" },
                            on: {
                              click: function($event) {
                                return _vm.gotoOrderPay(item)
                              }
                            }
                          },
                          [
                            _c("van-col", { attrs: { span: "2" } }, [
                              item.status == "0"
                                ? _c(
                                    "span",
                                    { staticClass: "Status StayColor" },
                                    [_vm._v("待")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.status == "1,5,6,7"
                                ? _c(
                                    "span",
                                    { staticClass: "Status Coloring" },
                                    [_vm._v("维")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.status == "10"
                                ? _c(
                                    "span",
                                    { staticClass: "Status CompleteColor" },
                                    [_vm._v("已")]
                                  )
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _c(
                              "van-col",
                              { attrs: { span: "23", offset: "1" } },
                              [
                                _c(
                                  "van-row",
                                  [
                                    _c(
                                      "van-col",
                                      {
                                        staticClass: "cont",
                                        attrs: { span: "24" }
                                      },
                                      [
                                        _c(
                                          "van-col",
                                          {
                                            staticClass: "address",
                                            attrs: { span: "24" }
                                          },
                                          [_vm._v(_vm._s(item.address))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "van-col",
                                          {
                                            staticClass: "reason",
                                            attrs: { span: "24" }
                                          },
                                          [_vm._v(_vm._s(item.reason))]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    item.status == "0"
                                      ? _c(
                                          "van-col",
                                          {
                                            staticClass: "statusText",
                                            attrs: { span: "24" }
                                          },
                                          [_vm._v("待接单")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    item.status == "1,5,6,7"
                                      ? _c(
                                          "van-col",
                                          {
                                            staticClass: "statusText",
                                            attrs: { span: "24" }
                                          },
                                          [_vm._v("维修中")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    item.status == "10"
                                      ? _c(
                                          "van-col",
                                          {
                                            staticClass: "statusText",
                                            attrs: { span: "24" }
                                          },
                                          [_vm._v("已完成")]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    )
                  : _vm._e()
              }),
              _vm._v(" "),
              _vm.OrderList.length == 0
                ? _c(
                    "van-row",
                    { staticClass: "noPayBar" },
                    [
                      _c("van-col", {
                        staticClass: "noPayPC",
                        attrs: { span: "24" }
                      }),
                      _vm._v(" "),
                      _c(
                        "van-col",
                        { staticClass: "text1 orange", attrs: { span: "24" } },
                        [_vm._v("没有找到该用户！")]
                      ),
                      _vm._v(" "),
                      _c(
                        "van-col",
                        { staticClass: "text2", attrs: { span: "24" } },
                        [_vm._v("去试试【自主信息填写缴费】吧！")]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "van-tab",
            { attrs: { title: "已完成" } },
            [
              _vm._l(_vm.OrderList, function(item) {
                return _vm.OrderList
                  ? _c(
                      "van-row",
                      { key: item.ID, attrs: { disabled: item.status != 0 } },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "billBar",
                            attrs: { href: "javascript:;" },
                            on: {
                              click: function($event) {
                                return _vm.gotoOrderPay(item)
                              }
                            }
                          },
                          [
                            _c("van-col", { attrs: { span: "2" } }, [
                              item.status == "0"
                                ? _c(
                                    "span",
                                    { staticClass: "Status StayColor" },
                                    [_vm._v("待")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.status == "1,5,6,7"
                                ? _c(
                                    "span",
                                    { staticClass: "Status Coloring" },
                                    [_vm._v("维")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.status == "10"
                                ? _c(
                                    "span",
                                    { staticClass: "Status CompleteColor" },
                                    [_vm._v("已")]
                                  )
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _c(
                              "van-col",
                              { attrs: { span: "23", offset: "1" } },
                              [
                                _c(
                                  "van-row",
                                  [
                                    _c(
                                      "van-col",
                                      {
                                        staticClass: "cont",
                                        attrs: { span: "24" }
                                      },
                                      [
                                        _c(
                                          "van-col",
                                          {
                                            staticClass: "address",
                                            attrs: { span: "24" }
                                          },
                                          [_vm._v(_vm._s(item.address))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "van-col",
                                          {
                                            staticClass: "reason",
                                            attrs: { span: "24" }
                                          },
                                          [_vm._v(_vm._s(item.reason))]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    item.status == "0"
                                      ? _c(
                                          "van-col",
                                          {
                                            staticClass: "statusText",
                                            attrs: { span: "24" }
                                          },
                                          [_vm._v("待接单")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    item.status == "1,5,6,7"
                                      ? _c(
                                          "van-col",
                                          {
                                            staticClass: "statusText",
                                            attrs: { span: "24" }
                                          },
                                          [_vm._v("维修中")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    item.status == "10"
                                      ? _c(
                                          "van-col",
                                          {
                                            staticClass: "statusText",
                                            attrs: { span: "24" }
                                          },
                                          [_vm._v("已完成")]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    )
                  : _vm._e()
              }),
              _vm._v(" "),
              _vm.OrderList.length == 0
                ? _c(
                    "van-row",
                    { staticClass: "noPayBar" },
                    [
                      _c("van-col", {
                        staticClass: "noPayPC",
                        attrs: { span: "24" }
                      }),
                      _vm._v(" "),
                      _c(
                        "van-col",
                        { staticClass: "text1 orange", attrs: { span: "24" } },
                        [_vm._v("没有找到该用户！")]
                      ),
                      _vm._v(" "),
                      _c(
                        "van-col",
                        { staticClass: "text2", attrs: { span: "24" } },
                        [_vm._v("去试试【自主信息填写缴费】吧！")]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ddd1a7c2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ddd1a7c2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/repairOrder/repairOrder.vue
// module id = null
// module chunks = 